import { derived, writable } from 'svelte/store';
import { idb } from '../db.js';

import { createId } from "../js/helper";

const DB_TABLE = `pc_users`;

const local = {
    users: JSON.parse(localStorage.getItem("pc_users"))
};

const initUsers = () => {
    const state = [
        {
            "uid":"151116c0-f313-4c8e-94da-e21c2a3730b0",
            "name":"Lola",
            "dob":"1988-02-18",
            "diets":[{"vegetarian":false},
            {"vegan":false},
            {"gluten free":false},
            {"dairy free":false},
            {"kosher":false},
            {"halal":false}],
            "type": "user"
        },
        {
            "uid":"151116c0-f313-4c8e-94da-e21c2a3730b1",
            "name":"Mia",
            "dob":"2019-11-21",
            "diets":[{"vegetarian":false},
            {"vegan":false},
            {"gluten free":false},
            {"dairy free":false},
            {"kosher":false},
            {"halal":false}],
            "type": "baby"
        },
        {
            "uid":"151116c0-f313-4c8e-94da-e21c2a3730b2",
            "name":"Nico",
            "dob":"1987-08-16",
            "diets":[{"vegetarian":false},
            {"vegan":false},
            {"gluten free":false},
            {"dairy free":false},
            {"kosher":false},
            {"halal":false}],
            "type": "user"
        }/*,
        {
            "uid":"151116c0-f313-4g8e-94da-e21c2a3730b2",
            "name":"Oreo",
            "dob":"1987-08-16",
            "diet":[],
            "type": "pet"
        },*/
    ];
    //const { subscribe, set, update } = writable(local.users || state);
    const { subscribe, set, update } = writable([]);
    const helpers = {
        init: async ( key, index ) => {
            // Default to get all lists if no index is set
            if( ! key ) {
                set(await idb.getAll( DB_TABLE ))
            // If just a key is provided return the record uid matches the key
            } else if ( ! index ){
                set([await idb.get( DB_TABLE, key)]);
            // If an index is also provide return the list of records where the index matches the key
            } else {
                set(await idb.getAllFromIndex.eq( DB_TABLE, index, key));
            }
        },
        add: async ( data ) => {
            console.log(data);
            update( state => [...state, data] );
            await idb.save(DB_TABLE, [data]);
        },
        find: async ( key, index ) => {
            // Default to get all lists if no index is set
            if( ! key ) {
                return await idb.getAll( DB_TABLE );
            // If just a key is provided return the record uid matches the key
            } else if ( ! index ){
                return await idb.get( DB_TABLE, key);
            // If an index is also provide return the list of records where the index matches the key
            } else {
                return await idb.getAllFromIndex.eq( DB_TABLE, index, key);
            }
        },
        save: async data => { if(data) await idb.save(DB_TABLE, data) },
        editSingleField: ( uid, field, data ) => { update( state => {
            state[state.findIndex( state => state.uid == uid)][field] = data;
            return [ ...state ]
        })},
        edit: ( uid, data ) => { update( state => {
            state[state.findIndex( state => state.uid == uid)] = data 
            return [...state]
        })},
        delete: async ( uid ) => { 
            update( current => current.filter( entry => entry.uid != uid) );
            idb.delete(DB_TABLE, uid );
        }
    }
    return {
        subscribe,
        set,
        update,
        ...helpers
    }
}
export const users = initUsers();

export const count = derived(
    users,
    $users => {return {
        user: $users.filter( user => user.type == "user").length,
        baby: $users.filter( user => user.type == "baby").length,
        pet: $users.filter( user => user.type == "pet").length
    }}
);

export const restrictions = derived (
    users,
    $users => {
        let r = {
            all: []
        };
        $users.forEach( user => {
            r[ user.uid ] = [] ;
            user.diets.forEach( entry => {
                for (const [ diet, has ] of Object.entries(entry)){
                    console.log(user.uid,diet,has);
                    if ( has ) {
                        r.all.push( diet ) ;
                        r[ user.uid ].push( diet );  
                    }
                };
            })
        });
        console.log(r);
        return r;
    }
)

export const newUser = {
    "uid" : createId.sm(),
    "name" : "new user",
    "picUrl" : "",
    "diets" : [
        {"vegetarian":false},
        {"vegan":false},
        {"gluten free":false},
        {"dairy free":false},
        {"kosher":false},
        {"halal":false}
    ],
    "type" : "user",
    "like" : [],
    "dislike" : []
};

users.subscribe(value => {
    localStorage.setItem("pc_users", JSON.stringify(value));
});